import React from 'react'

import { Grid as BaseGrid, styled } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 67px 100px 113px;
  ${props => props.theme.breakpoints.down('md')} {
    padding: 37px 50px 50px;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    padding: 10px 0;
  }
`
export const Grid = styled(({ ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`
export const Row = styled('div')`
  margin: ${props => props.margin};
  text-align: center;
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    width: ${props => props.width};
  }
`
export const RowRadio = styled('div')`
  text-align: left;
  width: 100%;
`
export const RowScroll = styled('div')`
  margin: 8px 0 0;
  text-align: center;
  width: 100%;
  max-height: 400px;
  overflow: auto;
`
export const Strong = styled('span')`
  font-weight: bold;
`
export const SubHeader = styled('span')`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
`

export const ContainerCheck = styled('div')`
  display: 'flex';
  justify-content: 'center';
  margin: ${props => props.margin};
`
export const MainCircle = styled('div')`
  width: 64px;
  height: 64px;
  background-color: ${props =>
    props.backgroundColor === 'success'
      ? props.theme.palette.green[95]
      : props.backgroundColor === 'warning'
        ? props.theme.palette.yellow[95]
        : props.theme.palette.red[95]};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`
export const StyledCheckIcon = styled(CheckIcon)`
  color: ${props => props.theme.palette.green[50]};
  font-size: 32px;
`
export const StyledCloseIcon = styled(CloseIcon)`
  color: ${props => props.theme.palette.red[50]};
  font-size: 32px;
`
